import o, { useMemo as h } from "react";
import _ from "../../../hooks/customization/useCustomization.js";
import { useTranslation as E } from "react-i18next";
import { useOrdering as v } from "../context.js";
import m from "./steps.module.scss.js";
function N() {
  const { t: a } = E(), {
    currentStep: d,
    back: p
  } = v(), {
    configuration: f,
    getTextTranslations: g
  } = _(), n = g("popup"), u = h(() => {
    if (f === void 0)
      return [];
    const c = ["uber", "glovo", "deliveroo", "justeat"], [i] = f.settings.configuration.scope.filter((r) => Object.entries(r.services ?? {}).some(
      ([t, e]) => c.includes(t) && (e == null ? void 0 : e.url) !== "" && (e == null ? void 0 : e.url) !== void 0
    )).sort(((r, t) => {
      const e = d.data.restaurants.find((l) => l.id === r.id), s = d.data.restaurants.find((l) => l.id === t.id);
      return ((e == null ? void 0 : e.distance) ?? 1 / 0) - ((s == null ? void 0 : s.distance) ?? 1 / 0);
    }));
    return i === void 0 ? [] : Object.entries(i.services).filter(
      ([r, t]) => {
        const { url: e } = t ?? {};
        return c.includes(r) && e;
      }
    ).map(([r, t]) => {
      const e = r.toLocaleLowerCase() ?? "", { url: s } = t ?? {};
      return {
        url: s,
        name: a(e)
      };
    });
  }, [d]);
  return /* @__PURE__ */ o.createElement("div", { "data-testid": "no-reach-step" }, /* @__PURE__ */ o.createElement("div", { className: m.formTitle }, /* @__PURE__ */ o.createElement("i", { onClick: () => p(), className: "lni lni-chevron-left" }), /* @__PURE__ */ o.createElement(
    "div",
    {
      dangerouslySetInnerHTML: {
        __html: (n == null ? void 0 : n.error_cannot_deliver) || a("shopLanding.address.error.cannotDeliver")
      }
    }
  )), u.length > 0 && /* @__PURE__ */ o.createElement("div", { className: `${m.error} ${m.noReachError}` }, (n == null ? void 0 : n.error_order_through) || a("shopLanding.address.error.orderThrough"), u.map(({ url: c, name: i }) => /* @__PURE__ */ o.createElement("a", { key: i, target: "_blank", href: c, rel: "noreferrer" }, i))));
}
export {
  N as NoReachStep
};
//# sourceMappingURL=NoReachStep.js.map
